import {Coordinates} from '@domain/coordinates';
import {ClosestProductionScheduleItemInPathGroup} from '@domain/production-schedule/closest-production-schedule-item-in-path-group';
import {findIndex, isEqual, size, sum} from 'lodash-es';

export function getClosestProductionScheduleItemAndIndexRelativeToMouseCoordinates(
  mouseCoordinates: Coordinates,
  productionScheduleItems: SVGGraphicsElement[]
): ClosestProductionScheduleItemInPathGroup {
  let indexOfClosestProductionScheduleItemInPathGroup = findIndex(productionScheduleItems, (productionScheduleItemInPathGroup: SVGGraphicsElement) => {
    const y = Number(productionScheduleItemInPathGroup.getAttribute('y'));
    const height = Number(productionScheduleItemInPathGroup.getAttribute('height'));

    return mouseCoordinates.y >= y && mouseCoordinates.y <= sum([y, height]);
  });

  if (isEqual(indexOfClosestProductionScheduleItemInPathGroup, -1)) {
    indexOfClosestProductionScheduleItemInPathGroup = size(productionScheduleItems) - 1;
  }

  return {
    element: productionScheduleItems[indexOfClosestProductionScheduleItemInPathGroup],
    index: indexOfClosestProductionScheduleItemInPathGroup
  };
}
